import mitt, { Emitter } from "mitt";

export function createEventBus<AppEvents extends Record<string, any>>() {
  const emitter: Emitter<AppEvents> = mitt<AppEvents>();

  const emitEvent = <K extends keyof AppEvents>(
    type: K,
    payload: AppEvents[K] = {} as AppEvents[K]
  ) => {
    emitter.emit(type, { ...payload, timestamp: new Date().toISOString() });
  };

  const onEvent = <K extends keyof AppEvents>(
    type: K,
    handler: (event: AppEvents[K]) => void
  ) => {
    emitter.on(type, handler);
  };

  const offEvent = <K extends keyof AppEvents>(
    type: K,
    handler: (event: AppEvents[K]) => void
  ) => {
    emitter.off(type, handler);
  };

  return {
    emitEvent,
    onEvent,
    offEvent,
    emitter,
  };
}

